<template>
  <div>
    <Layout :containers="containers">
      <template v-slot:header>
        <DefaultHeroBar
          :hasQuickStartCallout="false"
          :heroTitle="'Earn Your Share of MFC Wills incentive for signed and validated wills'"
          :heroDescription="'Simply get registered to unlock your earning potential'"
          :section="'advisersHeader'"
          :heroButtonText="''"
          :heroButtonLink="''"
        />
      </template>
      <template v-slot:advisorEnrolmentIntro>
        <MfcAdviserEnrolmentIntro />
      </template>
      <template v-slot:adviserEnrolmentAccentuatedContent>
        <AdviserEnrolmentAccentuatedContent
          :earningsBullet="mfcEarningsBullet"
          :channelNote="mfcChannelNote"
        />
      </template>
      <template v-slot:adviserEnrolment>
        <AdviserEnrolmentContent
          :allowedCompanyIds="allowedCompanyIds"
          :faqCategoriesOverride="mfcFaqCategories"
          :termsOverride="mfcTerms"
          :showFaqsBanner="false"
          :showWhatsNewBanner="false"
          :showCustomerBrochureBanner="false"
          @showErrorMessage="showErrorMessage"
        >
          <template v-slot:channelSelector>
            <AdviserChannelSelector :currentChannel="'mfc'" />
          </template>
        </AdviserEnrolmentContent>
      </template>
      <template v-slot:footer>
        <DefaultHeroBar
          :hasQuickStartCallout="false"
          :heroTitle="`Let's grow together`"
          :heroDescription="''"
          :section="'advisersFooter'"
          :heroButtonText="''"
          :heroButtonLink="''"
        />
      </template>
    </Layout>
    <ErrorSnackbar v-model="showError" :error="errorMessage" />
  </div>
</template>

<script>
  import { MFC_CHANNEL_COMPANY_IDS } from '@/constants/adviser-channel-companies';
  import {
    MFC_FAQ_CATEGORIES,
    MFC_TERMS,
    MFC_EARNINGS_BULLET,
    MFC_CHANNEL_NOTE,
  } from '@/constants/adviser-enrolment/mfc-content';
  import ErrorSnackbar from '@/components/common/ErrorSnackbar.vue';
  import Layout from '../../common/layouts/Layout.vue';
  import DefaultHeroBar from '../../common/DefaultHeroBar.vue';
  import AdviserEnrolmentContent from './AdviserEnrolmentContent.vue';
  import MfcAdviserEnrolmentIntro from './MfcAdviserEnrolmentIntro.vue';
  import AdviserChannelSelector from './AdviserChannelSelector.vue';
  import AdviserEnrolmentAccentuatedContent from './AdviserEnrolmentAccentuatedContent.vue';
  export default {
    name: 'MfcAdviserEnrolment',
    components: {
      Layout,
      DefaultHeroBar,
      AdviserEnrolmentContent,
      MfcAdviserEnrolmentIntro,
      AdviserChannelSelector,
      AdviserEnrolmentAccentuatedContent,
      ErrorSnackbar,
    },
    metaInfo: {
      meta: [
        {
          name: 'robots',
          content: 'nofollow',
        },
        {
          name: 'robots',
          content: 'noindex',
        },
      ],
    },
    data() {
      return {
        allowedCompanyIds: MFC_CHANNEL_COMPANY_IDS,
        mfcFaqCategories: MFC_FAQ_CATEGORIES,
        mfcTerms: MFC_TERMS,
        mfcEarningsBullet: MFC_EARNINGS_BULLET,
        mfcChannelNote: MFC_CHANNEL_NOTE,
        errorMessage: null,
        showError: false,
      };
    },
    methods: {
      showErrorMessage(errorMessage) {
        this.errorMessage = errorMessage;
        this.showError = true;
      },
    },
    computed: {
      containers() {
        return [
          {
            name: 'header',
            background: 'countryPattern',
            class: 'hero-banner',
          },
          {
            name: 'advisorEnrolmentIntro',
            background: 'countryPattern',
            fadedRow: true,
          },
          {
            name: 'adviserEnrolmentAccentuatedContent',
            class: 'adviser-enrolment section-margin',
          },
          { name: 'adviserEnrolment' },
        ];
      },
    },
  };
</script>
